import React from 'react';

import AnimatedP from '../Zanimowane/AnimatedP';
import Button from '../Buttons/Button';

export default function IntroB({ children, tytul, fontSize, refer, button, czyZanimowane, link }) {
    return (
        <div className='absolute left-[2rem] top-[14%] z-50 scale-[50%]
                        sm:left-[5rem] md:left-[9rem] md:top-[5%] sm:top-[24%] sm:scale-100'>

            <div className=''>
                <p className='absolute bottom-0 font-sen drop-shadow-2xl tracking-wide' style={{fontSize: fontSize}}>{tytul}</p>
                <div id='border-side' className='absolute w-32 h-1 left-2 top-4 rounded-full bg-red-500'></div>
                <div id='border-side' className='absolute w-32 h-1 left-16 top-8 rounded-full bg-red-500'></div>
                <div className='absolute top-20 left-2'>
                    <AnimatedP fontSize={fontSize} referencja={refer} czyZanimowane={czyZanimowane}>
                        {children}
                    </AnimatedP>
                    <AnimatedP fontSize={20} referencja={refer} czyZanimowane={czyZanimowane}>
                        {button && <Button tekst={"Show more"} link={link}/>}
                    </AnimatedP>
                    
                </div>
            </div>

        </div>
    )

}